import { mockBasketItemRenewal } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedRenewal } from '../../models/checkout-completed-item/checkout-completed-renewal.interface';
import { mockCheckoutCompletedRenewalConfirmation } from './checkout-completed-renewal-confirmation.mock';

export const mockCheckoutCompletedRenewal: CheckoutCompletedRenewal = {
  item: mockBasketItemRenewal,
  confirmation: mockCheckoutCompletedRenewalConfirmation,
};
